import React, { useState } from "react";
import Select, { components } from "react-select";
import { useTranslation } from 'react-i18next';
const MultiSelectCheckbox = ({
  options = [],
  selectedOptions = [],
  setSelectedOptions = () => {},
}) => {
  const { t } = useTranslation('multiSelect');
 // console.log(t);
  const [searchTerm, setSearchTerm] = useState("");

  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const Option = (props) => (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
        style={{ marginRight: 10 }}
      />
      {props.label}
    </components.Option>
  );

  const CustomMenuList = (props) => {
    const filteredValues = filteredOptions.map((opt) => opt.value);
    const selectedValues = selectedOptions.map((opt) => opt.value);

    const allFilteredSelected = filteredValues.every((val) =>
      selectedValues.includes(val)
    );

    const handleSelectAll = () => {
      if (allFilteredSelected) {
        // Deselect only filtered options
        const remaining = selectedOptions.filter(
          (opt) => !filteredValues.includes(opt.value)
        );
        setSelectedOptions(remaining);
      } else {
        // Select only filtered options
        const newSelections = [
          ...selectedOptions.filter(
            (opt) => !filteredValues.includes(opt.value)
          ),
          ...filteredOptions,
        ];
        setSelectedOptions(newSelections);
      }
    };

    return (
      // <components.MenuList {...props}>
      //   <div style={{ padding: "8px" }}>
      //     <div style={{ marginBottom: "8px" }}>
      //       <label>
      //         <input
      //           type="checkbox"
      //           checked={allFilteredSelected}
      //           onChange={handleSelectAll}
      //           style={{ marginRight: 10 }}
      //         />
      //         Select All
      //       </label>
      //     </div>
      //   </div>
      //   {props.children}
      // </components.MenuList>
      <components.MenuList {...props}>
        <div style={{ padding: "8px", color: "var(--text-body)" }}>
          <input
            type="text"
            placeholder={t('searchPlaceholder')}
            autoFocus
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => e.stopPropagation()}
            style={{
              width: "100%",
              padding: "6px 8px",
              marginBottom: "8px",
              borderRadius: "4px",
              border: "1px solid var(--line)",
              backgroundColor: "var(--surface)",
              color: "var(--text-body)",
            }}
          />
          <label>
            <input
              type="checkbox"
              checked={allFilteredSelected}
              onChange={handleSelectAll}
              style={{ marginRight: 10 }}
            />
            {t('selectAll')}
          </label>
        </div>
        {props.children}
      </components.MenuList>
    );
  };
  // Custom ValueContainer to show summary
  const CustomValueContainer = ({ children, ...props }) => {
    const selectedCount = props.getValue().length;

    const displayText =
      selectedCount === 0
       ? t('placeholder')
        : t('summary', { count: selectedCount });

    return (
      <components.ValueContainer {...props}>
        
<div style={{ marginLeft: 6, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
        {displayText}
      </div>

      </components.ValueContainer>
    );
  };
  return (
    <>
      <div style={{ marginBottom: "10px" }}>
       
      </div>

      <Select
        options={filteredOptions}
        isMulti
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{
          Option,
          MenuList: CustomMenuList,
          ValueContainer: CustomValueContainer,
        }}
        onChange={setSelectedOptions}
        value={selectedOptions}
        placeholder={t('placeholder')}
        onInputChange={(inputValue) => setSearchTerm(inputValue)}
        styles={{
          // react-select ships its own light theme through emotion, and those
          // inline styles beat our CSS. Driving them from the same custom
          // properties keeps the control in step with light/dark in both the
          // nerdlet and the standalone build; the vars resolve at paint time.
          control: (provided, state) => ({
            ...provided,
            minHeight: "40px",
            height: "40px",
            overflow: "hidden",
            backgroundColor: "var(--surface)",
            borderColor: state.isFocused ? "var(--global-primary)" : "var(--line)",
            boxShadow: "none",
            ":hover": { borderColor: "var(--global-primary)" },
          }),
          valueContainer: (provided) => ({
            ...provided,
            height: "40px",
            padding: "0 8px",
            color: "var(--text-body)",
          }),
          indicatorsContainer: (provided) => ({ ...provided, height: "40px" }),
          indicatorSeparator: (provided) => ({
            ...provided,
            backgroundColor: "var(--line)",
          }),
          dropdownIndicator: (provided) => ({
            ...provided,
            color: "var(--text-muted)",
          }),
          placeholder: (provided) => ({ ...provided, color: "var(--text-muted)" }),
          input: (provided) => ({ ...provided, color: "var(--text-body)" }),
          menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            maxHeight: 250,
            overflowY: "auto",
            backgroundColor: "var(--surface)",
            border: "1px solid var(--line)",
          }),
          menuList: (provided) => ({
            ...provided,
            backgroundColor: "var(--surface)",
          }),
          option: (provided, state) => ({
            ...provided,
            color: "var(--text-body)",
            backgroundColor: state.isFocused ? "var(--surface-muted)" : "transparent",
            ":active": { backgroundColor: "var(--surface-muted)" },
          }),
          noOptionsMessage: (provided) => ({
            ...provided,
            color: "var(--text-muted)",
          }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
      />
    </>
  );
};

export default MultiSelectCheckbox;
